<div class="px-4">
  <div class="grid">
    <ng-container *ngFor="let item of cardList">
      <ng-container
        *ngTemplateOutlet="statCard; context: { $implicit: item }"
      ></ng-container>
    </ng-container>
  </div>
</div>